import { AxiosResponse, CancelToken } from "axios";
import http from "../../../../shared/http";
import { ReservationReadRequestDto, ReservationReadResponseDto } from "./dtos";

export const readReservation = async (
  params: ReservationReadRequestDto,
  cancelToken: CancelToken
): Promise<AxiosResponse<ReservationReadResponseDto>> => {
  const { reservationId } = params;
  return await http.get<ReservationReadResponseDto>(
    `/reservation?reservation=${reservationId}`,
    { cancelToken }
  );
};
